import { render, staticRenderFns } from "./Avisos.vue?vue&type=template&id=08c3631f&scoped=true&"
import script from "./Avisos.vue?vue&type=script&lang=js&"
export * from "./Avisos.vue?vue&type=script&lang=js&"
import style0 from "./Avisos.vue?vue&type=style&index=0&id=08c3631f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c3631f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
